import { useEffect } from "react";
import { shallow } from "zustand/shallow";
import { useSuperGiveAwayStore, useWebUserStore } from "../../../../CommonStores";
import { formatNameCapitalize } from "../../../../../Common/utils/common";
import LoginOTPInterfaceStore from "../../interface/LoginOTPInterface";

const useWebUserDerivedSync = () => {
  const [user, signInOtpFirstName] = useWebUserStore(
    (state) => [state.user, state.signInOtpFirstName],
    shallow
  );

  const [ongoingGiveaway] = useSuperGiveAwayStore(
    (state) => [state.ongoingGiveaway],
    shallow
  );

  useEffect(() => {
    const rawGreetingName =
      user?.firstName?.trim() || signInOtpFirstName?.trim() || "";
    const greetingFirstName =
      formatNameCapitalize(rawGreetingName) || "there";

    const fixPaymentGiveawayHighlight =
      ongoingGiveaway?.title?.trim() || "current giveaway";

    const { setGreetingFirstName, setFixPaymentGiveawayHighlight } =
      LoginOTPInterfaceStore.getState();
    setGreetingFirstName(greetingFirstName);
    setFixPaymentGiveawayHighlight(fixPaymentGiveawayHighlight);
  }, [ongoingGiveaway, signInOtpFirstName, user]);
};

export default useWebUserDerivedSync;
